/**
 * Filtres Vue
 */

/**
 * Filtre de formattage monétaire
 */
Vue.filter('currency', function (value) {
    if (!value) {
        value = 0
    }

    if (value == 0) {
        return $t('GRATUIT')
    }

    value = new Intl.NumberFormat('fr-FR', {
        style: 'currency',
        currency: 'EUR'
    }).format(value)
    return value
})
/**
 * Filtre de formattage monétaire sans valeur pas défaut
 */

Vue.filter('currency2', function (value) {
    if (!value) {
        value = 0
    }

    value = new Intl.NumberFormat('fr-FR', {
        style: 'currency',
        currency: 'EUR'
    }).format(value)
    return value
})

// Retourne une string avec chaque mot commencant par une majuscule
Vue.filter('capitalize', function (value) {
    return value
        .split(' ')
        .map((x) => {
            const word = x.toLowerCase()

            return word.charAt(0).toUpperCase() + word.slice(1)
        })
        .join(' ')
})
